module.exports = __webpack_public_path__ + "static/media/NMIMS.9baae4f9.jpeg";